import { useCallback, useEffect } from 'react';

import { CommodityOption } from '@/actions/products/types';
import { Select } from '@/ui-lib/select';

import { InputWrapper } from './Inputs';

export default function CommoditySelector({
    commodities,
    isLoading,
    value,
    error,
    setValue,
    setStowageFactor,
    color = 'lightGrey',
    className,
}: {
    commodities: CommodityOption[];
    isLoading?: boolean;

    value: string;
    setValue: (value: string | null) => void;

    error?: string;

    color?: 'lightGrey' | 'grey';
    className?: string;

    stowageFactor?: number;
    setStowageFactor?: (value: number | null) => void;
}) {
    // const pinning = usePinning("commodity", DBBackedPinAdapter);

    const onSetValue = useCallback(
        (newValue: string | null) => {
            setValue(newValue || null);

            if (newValue && setStowageFactor) {
                setStowageFactor(null);
            }
        },
        [setValue, setStowageFactor]
    );

    useEffect(() => {
        if (isLoading) {
            return;
        }

        // If we have a value, and we cannot find it in the commodities list, see if we can find it by frcId
        if (value && !commodities.find((c) => c.value === value)) {
            const commodity = commodities.find((c) => c.frcId === value);
            if (commodity) {
                onSetValue(commodity.value);
                if (setStowageFactor) {
                    setStowageFactor(commodity.stowageFactorCBFT);
                }
                return;
            }

            // If we still cannot find it, reset the value
            onSetValue(null);
            if (setStowageFactor) {
                setStowageFactor(null);
            }
        }
    }, [value, commodities, onSetValue, setStowageFactor, isLoading]);

    return (
        <InputWrapper id={'commodity'} isRequired label="Commodity" error={error} className={className}>
            <Select
                placeholder="Commodity"
                multiple={false}
                rounded
                color={color}
                mode="dark"
                loadingAnimation="pulse"
                options={commodities}
                value={value ?? null}
                onChange={onSetValue}
                loading={isLoading}
                hasError={!!error}
                /*
        loading={isLoading || pinning.pending}
        pinEnabled
        pinOption={pinning.pinOption}
        pinnedOptions={pinning.pinnedOptions}
        */
            />
        </InputWrapper>
    );
}
